/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffDocumentPage } from './StaffDocumentPage';
import {
    StaffDocumentPageFromJSON,
    StaffDocumentPageFromJSONTyped,
    StaffDocumentPageToJSON,
    StaffDocumentPageToJSONTyped,
} from './StaffDocumentPage';

/**
 * 
 * @export
 * @interface StaffDocumentPageResponse
 */
export interface StaffDocumentPageResponse {
    /**
     * 
     */
    data: StaffDocumentPage;
}

/**
 * Check if a given object implements the StaffDocumentPageResponse interface.
 */
export function instanceOfStaffDocumentPageResponse(value: object): value is StaffDocumentPageResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function StaffDocumentPageResponseFromJSON(json: any): StaffDocumentPageResponse {
    return StaffDocumentPageResponseFromJSONTyped(json, false);
}

export function StaffDocumentPageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffDocumentPageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StaffDocumentPageFromJSON(json['data']),
    };
}

export function StaffDocumentPageResponseToJSON(json: any): StaffDocumentPageResponse {
    return StaffDocumentPageResponseToJSONTyped(json, false);
}

export function StaffDocumentPageResponseToJSONTyped(value?: StaffDocumentPageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StaffDocumentPageToJSON(value['data']),
    };
}

